import { Injectable } from '@angular/core';
import { ModelStateService } from './model-state.service';
import { BaseModel } from '../../view-model/base-model';
import { FieldModel } from '../../view-model/field-model';
import { IdRefModel } from '../../view-model/type/id-ref.model';
import { IndicatorModel } from '../../view-model/type/indicator-model';
import { IdModel } from '../../view-model/type/id-model';
import { IndicatorData } from '../../store/app.state';

export class IndicatorLabel {
  id: string;
  label: string;
  showId: boolean;
}

/**
 * update indicators label for id-ref component
 */
@Injectable({
  providedIn: 'root',
})
export class IndicatorLabelService {
  public updateIndicatorsLabel(
    indicators: Map<string, IndicatorData>,
    scheme: string,
    model: BaseModel
  ): IndicatorLabel[] {
    const options: IndicatorLabel[] = [];
    let label: string;
    const indicatorsValues = indicators?.get(scheme)?.values ?? [];
    for (const value of indicatorsValues) {
      if (model.noticeNode.id === 'OPT-310-Tender') {
        const opt310Map: Map<string, string> = this.createMap(model, indicators);
        label = opt310Map.get(value.id) || `${value.id}`;
      } else {
        label = value.label ?? `${value.id}`;
      }
      options.push({ id: value.id, label, showId: true });
    }
    return options;
  }

  /**
   * create map of reference id (OPT-210-Tenderer) and organization official name (BT-500-Organization-Company)
   * possible options tpa-0000 tpa-0000, tpa-0000 org-0000, tpa-0000 adesso
   *
   * @param model
   * @param indicators
   * @private
   */
  private createMap(model: BaseModel, indicators: Map<string, IndicatorData>): Map<string, string> {
    const tenderMap: Map<string, string> = new Map();
    const tenderingPartyList = [];
    let orgLabel = '';
    const opt210Models = ModelStateService.findModelsById(model.root, 'OPT-210-Tenderer');
    opt210Models.forEach(opt210 => tenderingPartyList.push(opt210.parent));

    for (const tenderingParty of tenderingPartyList) {
      const opt210: FieldModel<string> = ModelStateService.findModelById(
        tenderingParty,
        'OPT-210-Tenderer'
      );
      const opt300Models = ModelStateService.findModelsById(tenderingParty, 'OPT-300-Tenderer');

      if (opt300Models.length === 0) {
        continue;
      } else if (opt300Models.length === 1) {
        orgLabel = this.findOrganizationLabel((opt300Models[0] as IdRefModel).value, indicators);
      } else if (opt300Models.length > 1) {
        orgLabel = this.findOrganizationLabelOfLeadTenderer(opt300Models as IdModel[], indicators);
      }
      tenderMap.set(opt210?.value, orgLabel);
    }

    return tenderMap;
  }

  private findOrganizationLabelOfLeadTenderer(
    opt300Models: IdModel[],
    indicators: Map<string, IndicatorData>
  ): string {
    for (const opt300model of opt300Models) {
      if (opt300model.value) {
        const opt170: IndicatorModel = ModelStateService.findModelById(
          opt300model.parent,
          'OPT-170-Tenderer'
        );
        if (opt170?.value) {
          return this.findOrganizationLabel(opt300model.value, indicators);
        }
      }
    }
  }

  private findOrganizationLabel(
    organizationId: string,
    indicators: Map<string, IndicatorData>
  ): string {
    let label = '';
    indicators?.get('ORG')?.values.forEach(value => {
      if (value.id === organizationId) {
        label = value.label ?? `${value.id}`;
      }
    });
    return label;
  }
}
